<template>
  <div class="">

    <div class="has-bg-white is-border">
      <div
        class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex">
        <div class="is-self-centered"><span class="is-uppercase title is-6">Choix</span></div>
      </div>
      <template v-for="(choice, idx) in choices">
        <choix-list :key="idx + '-choix'" :idx='idx' :source="choice" :canEdit='canEdit'
                    @commitAdv="commitAdv()" @saveAdv="saveAdv()" @deleteList="deleteList"></choix-list>
      </template>
      <div class="">
        <button @click="addChoice" :disabled='!(isAdmin || isSectorManager)' class="button is-grey-dark is-fullwidth is-radiusless is-min-height-50"><span>Ajouter une liste</span>
        </button>
      </div>
    </div>

    <div class="has-bg-white is-border is-margin-top-xsmall">
      <div class="columns is-gapless has-bg-white is-min-height-50">
        <div class="column is-narrow is-self-centered is-padding-left has-text-left">
          <div class="is-self-centered">
            <span class="is-uppercase title is-6">TMA</span>
          </div>
        </div>
      </div>

      <div class="columns is-gapless has-bg-white-bis is-border-top">
        <div class="column is-narrow is-flex is-padding-small"
             :class="[(tma.architect_devis && tma.architect_devis.date && tma.architect_devis.amount) ? 'has-bg-success' : 'has-bg-danger']">
            <span class="icon has-text-white is-self-centered">
              <i v-if="tma.architect_devis && tma.architect_devis.date && tma.architect_devis.amount"
                 class="fas fa-check-circle"></i>
              <i v-else class="fas fa-clock"></i>
            </span>
        </div>
        <div class="column is-padding-top">
          <div class="is-padding-left is-padding-bottom">
            <span class="title is-4 is-uppercase has-text-weight-medium">Devis architecte</span>
          </div>
          <div class="columns is-gapless is-padding-left">
            <div class="column is-3 is-padding-right">
              <label for="" class="label">Devis TTC</label>
            </div>
            <div class="column is-3 is-padding-right">
              <label for="" class="label">Montant perçu</label>
            </div>
            <div class="column">
              <label for="" class="label">Réception devis</label>
            </div>
          </div>
          <div class="columns is-gapless is-margin-top-xsmall is-padding-left has-bg-grey-lighter is-vcentered is-border-top row-width-actions-bar" :class="{'has-content-disabled' : !(isAdmin || isSectorManager)}">
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p class="control" :class="{'is-border': !(isAdmin || isSectorManager)}">
                  <input id="architect_devis_amount" type="number"
                         class="input has-text-centered has-text-weight-bold"
                         v-model.number="tma.architect_devis.amount" @change="commitAdv"
                         :disabled="!(isAdmin || isSectorManager)">
                </p>
                <p class="control is-inline-flex is-border has-bg-grey-lighter has-text-primary is-vcentered is-padding-left-small is-padding-right-small is-nowrap">
                  <b>{{$currency}} TTC</b>
                </p>
              </div>
            </div>
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p class="control" :class="{'is-border': !(isAdmin || isSectorManager)}">
                  <input id="architect_devis_amount_percu" type="number"
                         class="input has-text-centered has-text-weight-bold"
                         v-model.number="tma.architect_devis.amount_percu" @change="commitAdv"
                         :disabled="!(isAdmin || isSectorManager)">
                </p>
                <p class="control is-inline-flex is-border has-bg-grey-lighter has-text-primary is-vcentered is-padding-left-small is-padding-right-small is-nowrap">
                  <b>{{$currency}} TTC</b>
                </p>
              </div>
            </div>
            <div class="column is-3">
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr type="date" class="input"
                              :class="{'is-border': !(isAdmin || isSectorManager)}"
                              @on-change="commitAdv"
                              :disabled="!(isAdmin || isSectorManager)"
                              v-model="tma.architect_devis.date"
                              :config="dateConfig">
                  </flat-pickr>
                </div>
              </div>
            </div>
            <div class="column"></div>
            <template v-if="'document' in tma.architect_devis && tma.architect_devis.document && 'cloudinary_id' in tma.architect_devis.document">
              <div v-if="seeDocArchi" class="column is-narrow is-border-left">
                <button class="page-header-btn is-small is-square tooltip is-tooltip-top"
                        @click="download('architect_devis')" data-tooltip="Télécharger document lié"><span
                  class="icon is-size-4"><i class="fal fa-download"></i></span></button>
              </div>
              <div v-if="(isAdmin || isSectorManager)" class="column is-narrow is-border-left">
                <button class="page-header-btn is-small is-square tooltip is-tooltip-top"
                        @click="unlink('architect_devis')" data-tooltip="Supprimer document lié"><span
                  class="icon is-size-4"><i class="fal fa-unlink"></i></span></button>
              </div>
            </template>
            <template v-else-if="isAdmin || isSectorManager">
              <div class="column is-narrow has-bg-white is-border-left">
                <div class="file">
                  <label class="page-header-btn is-small is-square tooltip is-tooltip-top"
                         data-tooltip="Lier un document">
                    <input class="file-input" type="file" accept='image/png, image/jpeg, .pdf'
                           @change="processFile($event, 'architect_devis')"
                           name="resume">
                    <span class="">
                      <span v-if="uploading === 'architect_devis'" class="icon is-size-4 is-self-centered"><i
                        class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
                      <span v-else class="icon is-size-4 is-self-centered"><i class="fal fa-link"></i></span>
                    </span>
                  </label>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="columns is-gapless has-bg-white-bis is-border-top">
        <div class="column is-narrow is-flex is-padding-small"
             :class="[(tma.promoteur_devis && tma.promoteur_devis.date && tma.promoteur_devis.amount) ? 'has-bg-success' : 'has-bg-danger']">
            <span class="icon has-text-white is-self-centered">
              <i v-if="tma.promoteur_devis && tma.promoteur_devis.date && tma.promoteur_devis.amount"
                 class="fas fa-check-circle"></i>
              <i v-else class="fas fa-clock"></i>
            </span>
        </div>
        <div class="column is-padding-top">
          <div class="is-padding-left is-padding-bottom">
            <span class="title is-4 is-uppercase has-text-weight-medium">Devis Promoteur</span>
          </div>
          <div class="columns is-gapless is-padding-left">
            <div class="column is-3 is-padding-right">
              <label for="" class="label">Devis TTC</label>
            </div>
            <div class="column is-3 is-padding-right">
              <label for="" class="label">Montant perçu</label>
            </div>
            <div class="column">
              <label for="" class="label">Réception devis</label>
            </div>
          </div>

          <div :class="{'has-content-disabled' : !(isAdmin || isSectorManager)}"
            class="columns is-gapless is-margin-top-xsmall is-padding-left has-bg-grey-lighter is-vcentered is-border-top row-width-actions-bar">
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p class="control" :class="{'is-border': !(isAdmin || isSectorManager)}">
                  <input id="promoteur_devis_amount" type="number"
                         class="input has-text-centered has-text-weight-bold"
                         v-model.number="tma.promoteur_devis.amount" @change="commitAdv"
                         :disabled="!(isAdmin || isSectorManager)">
                </p>
                <p
                  class="control is-inline-flex is-border has-bg-grey-lighter has-text-primary is-vcentered is-padding-left-small is-padding-right-small is-nowrap">
                  <b>{{$currency}} TTC</b>
                </p>
              </div>
            </div>
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p class="control" :class="{'is-border': !(isAdmin || isSectorManager)}">
                  <input id="promoteur_devis_amount_percu" type="number"
                         class="input has-text-centered has-text-weight-bold"
                         v-model.number="tma.promoteur_devis.amount_percu" @change="commitAdv"
                         :disabled="!(isAdmin || isSectorManager)">
                </p>
                <p
                  class="control is-inline-flex is-border has-bg-grey-lighter has-text-primary is-vcentered is-padding-left-small is-padding-right-small is-nowrap">
                  <b>{{$currency}} TTC</b>
                </p>
              </div>
            </div>
            <div class="column is-3">
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr type="date" class="input"
                              :class="{'is-border': !(isAdmin || isSectorManager)}"
                              @on-change="commitAdv"
                              :disabled="!(isAdmin || isSectorManager)"
                              v-model="tma.promoteur_devis.date"
                              :config="dateConfig"
                              >
                  </flat-pickr>
                </div>
              </div>
            </div>
            <div class="column"></div>
            <template v-if="tma.promoteur_devis.document && 'cloudinary_id' in tma.promoteur_devis.document">
              <div v-if="seeDocPromoteur" class="column is-narrow is-border-left">
                <button class="page-header-btn is-small is-square tooltip is-tooltip-top"
                        @click="download('promoteur_devis')" data-tooltip="Télécharger document lié"><span
                  class="icon is-size-4"><i class="fal fa-download"></i></span></button>
              </div>
              <div class="column is-narrow is-border-left">
                <button class="page-header-btn is-small is-square tooltip is-tooltip-top"
                        @click="unlink('promoteur_devis')" data-tooltip="Supprimer document lié"><span
                  class="icon is-size-4"><i class="fal fa-unlink"></i></span></button>
              </div>
            </template>
            <template v-else-if="isAdmin || isSectorManager">
              <div class="column is-narrow has-bg-white is-border-left">
                <div class="file">
                  <label class="page-header-btn is-small is-square tooltip is-tooltip-top"
                         data-tooltip="Lier un document">
                    <input class="file-input" type="file" accept='image/png, image/jpeg, .pdf'
                           @change="processFile($event, 'promoteur_devis')"
                           name="resume">
                    <span class="">
                      <span v-if="uploading === 'promoteur_devis'" class="icon is-size-4 is-self-centered"><i
                        class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
                      <span v-else class="icon is-size-4 is-self-centered"><i class="fal fa-link"></i></span>
                    </span>
                  </label>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="columns is-gapless has-bg-white-bis is-border-top">
        <div class="column is-narrow is-flex is-padding-small"
             :class="[(tma.accepted_devis && tma.accepted_devis.date && tma.accepted_devis.amount) ? 'has-bg-success' : 'has-bg-danger']">
            <span class="icon has-text-white is-self-centered">
              <i v-if="tma.accepted_devis && tma.accepted_devis.date && tma.accepted_devis.amount"
                 class="fas fa-check-circle"></i>
              <i v-else class="fas fa-clock"></i>
            </span>
        </div>
        <div class="column is-padding-top">
          <div class="is-padding-left is-padding-bottom">
            <span class="title is-4 is-uppercase has-text-weight-medium">Devis client</span>
          </div>
          <div class="columns is-gapless is-padding-left">
            <div class="column is-3 is-padding-right">
              <label for="" class="label">Devis TTC</label>
            </div>
            <div class="column is-3 is-padding-right">
              <label for="" class="label">Montant perçu</label>
            </div>
            <div class="column">
              <label for="" class="label">Réception devis</label>
            </div>
          </div>
          <div :class="{'has-content-disabled' : !(isAdmin || isSectorManager)}"
            class="columns is-gapless is-margin-top-xsmall is-padding-left has-bg-grey-lighter is-vcentered is-border-top row-width-actions-bar">
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p class="control" :class="{'is-border': !(isAdmin || isSectorManager)}">
                  <input id="accepted_devis_amount" type="number"
                         class="input has-text-centered has-text-weight-bold"
                         v-model.number="tma.accepted_devis.amount" @change="commitAdv"
                         :disabled="!(isAdmin || isSectorManager)">
                </p>
                <p
                  class="control is-inline-flex is-border has-bg-grey-lighter has-text-primary is-vcentered is-padding-left-small is-padding-right-small is-nowrap">
                  <b>{{$currency}} TTC</b>
                </p>
              </div>
            </div>
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p class="control" :class="{'is-border': !(isAdmin || isSectorManager)}">
                  <input id="accepted_devis_amount_percu" type="number"
                         class="input has-text-centered has-text-weight-bold"
                         v-model.number="tma.accepted_devis.amount_percu" @change="commitAdv"
                         :disabled="!(isAdmin || isSectorManager)">
                </p>
                <p
                  class="control is-inline-flex is-border has-bg-grey-lighter has-text-primary is-vcentered is-padding-left-small is-padding-right-small is-nowrap">
                  <b>{{$currency}} TTC</b>
                </p>
              </div>
            </div>
            <div class="column is-3">
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr type="date" class="input"
                              :class="{'is-border': !(isAdmin || isSectorManager)}"
                              @on-change="commitAdv"
                              :disabled="!(isAdmin || isSectorManager)"
                              v-model="tma.accepted_devis.date"
                              :config="dateConfig">
                  </flat-pickr>
                </div>
              </div>
            </div>
            <div class="column"></div>
            <template v-if="tma.accepted_devis.document && 'cloudinary_id' in tma.accepted_devis.document">
              <div v-if="seeDocDevis" class="column is-narrow is-border-left">
                <button class="page-header-btn is-small is-square tooltip is-tooltip-top"
                        @click="download('accepted_devis')" data-tooltip="Télécharger document lié"><span
                  class="icon is-size-4"><i class="fal fa-download"></i></span></button>
              </div>
              <div class="column is-narrow is-border-left">
                <button class="page-header-btn is-small is-square tooltip is-tooltip-top"
                        @click="unlink('accepted_devis')" data-tooltip="Supprimer document lié"><span
                  class="icon is-size-4"><i class="fal fa-unlink"></i></span></button>
              </div>
            </template>
            <template v-else-if="isAdmin || isSectorManager">
              <div class="column is-narrow has-bg-white is-border-left">
                <div class="file">
                  <label class="page-header-btn is-small is-square tooltip is-tooltip-top"
                         data-tooltip="Lier un document">
                    <input class="file-input" type="file" accept='image/png, image/jpeg, .pdf'
                           @change="processFile($event, 'accepted_devis')"
                           name="resume">
                    <span class="">
                      <span v-if="uploading === 'accepted_devis'" class="icon is-size-4 is-self-centered"><i
                        class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
                      <span v-else class="icon is-size-4 is-self-centered"><i class="fal fa-link"></i></span>
                    </span>
                  </label>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isAdmin || isSectorManager" class="has-bg-white is-border is-margin-top-xxsmall">
      <div class="row-width-actions-bar columns is-gapless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
          <button class="page-header-btn is-small is-square" @click="openComment = !openComment"><span
            class="icon is-size-4">
            <i v-if="!openComment" class="fal fa-chevron-down"></i>
            <i v-else class="fal fa-chevron-up"></i>
            </span></button>
        </div>
      </div>
      <template v-if="openComment">
        <div v-if="!openWysi" class="vadDiscussion is-border-top">
          <div
            class="vadDiscussion--bulle is-size-6 is-min-height-50 vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div class="content" v-if="(isAdmin || isSectorManager) && adv.choix_et_tma.comment" v-html="adv.choix_et_tma.comment"></div>
            <div class="content" v-else>Aucun commentaire</div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button @click="openWysiwyg" class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="is-border-top columns is-gapless">
          <div class="column" v-if="isAdmin || isSectorManager">
            <wysiwyg-editor
              :light='true' :tooltip-top="true"
              :model="commentaire"
              @change="val => commentaire = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button @click="saveAdv()" type="button" class="button is-success">
                <span class="icon is-small"><i class="fal fa-save"></i></span>
              </button>
            </div>
            <div class="">
              <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="openWysi = false">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { AdvMx, DefaultValues } from '@/mixins'
  import ChoixList from './ChoixList'

  export default {
    name: 'ChoixEtTma',
    mixins: [AdvMx, DefaultValues],
    components: { ChoixList },
    data () {
      return {
        openComment: true,
        uploading: null,
        openWysi: false,
        commentaire: null,
        choices: [],
        tma: null,
        selectedRow: null
      }
    },
    computed: {
      tmaTotalAmount () {
        return (this.tma.architect_devis.amount || 0) +
          (this.tma.promoteur_devis.amount || 0) +
          (this.tma.accepted_devis.amount || 0)
      },
      tmaTotalAmountPercu () {
        return (this.tma.architect_devis.amount_percu || 0) +
          (this.tma.promoteur_devis.amount_percu || 0) +
          (this.tma.accepted_devis.amount_percu || 0)
      },
      seeDocArchi () {
        if (this.isAdmin || this.isSectorManager) return true
        else if ('document' in this.tma.architect_devis && this.tma.architect_devis.document) {
          if ('display' in this.tma.architect_devis.document && this.tma.architect_devis.document.display) return true
          else return false
        } else {
          return false
        }
      },
      seeDocPromoteur () {
        if (this.isAdmin || this.isSectorManager) return true
        else if ('document' in this.tma.promoteur_devis && this.tma.promoteur_devis.document) {
          if ('display' in this.tma.promoteur_devis.document && this.tma.promoteur_devis.document.display) return true
          else return false
        } else {
          return false
        }
      },
      seeDocDevis () {
        if (this.isAdmin || this.isSectorManager) return true
        else if ('document' in this.tma.accepted_devis && this.tma.accepted_devis.document) {
          if ('display' in this.tma.accepted_devis.document && this.tma.accepted_devis.document.display) return true
          else return false
        } else {
          return false
        }
      }
    },
    methods: {
      openWysiwyg () {
        this.openWysi = true
        this.$nextTick(() => {
          let selection = document.getSelection()
          let range = document.createRange()
          let contenteditable = document.getElementsByClassName('ql-editor')
          contenteditable = contenteditable[contenteditable.length - 1]
          if (contenteditable.lastChild.nodeType === 3) {
            range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
          } else {
            range.setStart(contenteditable, contenteditable.childNodes.length)
          }
          selection.removeAllRanges()
          selection.addRange(range)
        })
      },
      deleteList (index) {
        this.choices.splice(index, 1)
        this.$nextTick(() => {
          this.commitAdv()
        })
      },
      saveAdv () {
        let adv = Object.assign({}, this.adv)
        this.$set(adv['choix_et_tma'], 'comment', this.commentaire)
        this.$set(adv['choix_et_tma'], 'choices', this.choices)
        this.$set(adv['choix_et_tma'], 'tma', this.tma)
        this.$emit('saveAdv', adv)
        this.openWysi = false
      },
      unlink (from) {
        let empty = {
          account: null,
          cloudinary_id: null,
          cloudinary_version: null,
          filename: null,
          fus_id: null,
          id: null,
          path: null
        }
        switch (from) {
          case 'accepted_devis':
            this.$set(this.tma.accepted_devis, 'document', empty)
            break
          case 'architect_devis':
            this.$set(this.tma.architect_devis, 'document', empty)
            break
          case 'promoteur_devis':
            this.$set(this.tma.promoteur_devis, 'document', empty)
            break
        }
        this.commitAdv()
      },
      download (from) {
        let link = document.createElement('a')
        switch (from) {
          case 'accepted_devis':
            link.href = this.tma.accepted_devis.document.path
            break
          case 'architect_devis':
            link.href = this.tma.architect_devis.document.path
            break
          case 'promoteur_devis':
            link.href = this.tma.promoteur_devis.document.path
            break
        }
        link.target = '_blank'
        link.click()
      },
      async processFile (event, from) {
        let file = event.target.files[0]
        let files = new FormData()
        files.append('file[]', file, file.name)
        this.uploading = from
        let document = null
        try {
          let res = await this.$fus.post({ data: files })
          document = res.data[0]
          document.fus_id = document.id
        } catch (e) {
          console.log(e)
        }
        if (document) {
          switch (from) {
            case 'accepted_devis':
              this.tma.accepted_devis.document = Object.assign({}, document)
              break
            case 'architect_devis':
              this.tma.architect_devis.document = Object.assign({}, document)
              break
            case 'promoteur_devis':
              this.tma.promoteur_devis.document = Object.assign({}, document)
              break
          }
          this.uploading = null
          this.commitAdv()
        } else {
          this.uploading = null
        }
      },
      openReminder () {
        this.$store.commit('setQuickview', { mode: 'NEW_REMINDER' })
      },
      addChoice (save = true) {
        if (this.isAdmin || this.isSectorManager || this.choices.length < 1) {
          this.choices.push({
            check: false,
            name: null,
            date: null,
            comment: null
          })
          if (save) {
            this.commitAdv()
          }
        }
      },
      removeChoice (index) {
        this.choices.splice(index, 1)
        this.commitAdv()
      },
      commitAdv (editedAdv, save = false) {
        let adv = Object.assign({}, this.adv)
        this.$set(adv['choix_et_tma'], 'choices', this.choices)
        this.$set(adv['choix_et_tma'], 'tma', this.tma)
        this.$emit('commit', adv, save)
        this.openWysi = false
      }
    },
    created () {
      if (this.adv.choix_et_tma.comment) this.commentaire = this.adv.choix_et_tma.comment
      if (!this.adv.choix_et_tma.choices || !this.adv.choix_et_tma.choices.length) {
        this.adv.choix_et_tma.choices = []
      }
      if (this.adv.choix_et_tma.choices && this.adv.choix_et_tma.choices.length) {
        this.choices = this.adv.choix_et_tma.choices.slice()
      } else this.addChoice(false)
      this.tma = Object.assign({}, this.adv.choix_et_tma.tma)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/ChoixEtTma.vue